import { Container } from '@/components/Container';
import { useTranslation } from '@/hooks/useTranslation';

/* ═══════════════════════════════════════════
   INTRODUÇÃO — Contexto essencial da ilha
   ═══════════════════════════════════════════ */

export function IntroducaoSection() {
  const { t } = useTranslation();

  return (
    <section id="introducao" className="py-16 sm:py-20 bg-white">
      <Container>
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <span className="font-body text-sm text-coral font-semibold uppercase tracking-wider">
              {t('guide.intro.overline')}
            </span>
            <h2 className="font-display text-4xl sm:text-5xl text-warm-dark mt-2">
              {t('guide.intro.title')}
            </h2>
          </div>

          <div className="space-y-5 font-editorial text-lg text-warm-gray leading-relaxed">
            <p>
              {t(
                'guide.intro.p1',
                'A Ilha do Mel tem 11 km de extensão e cerca de 90% de sua área é preservada. Não há ruas pavimentadas nem carros — a locomoção é a pé, por trilhas de areia e passadiços de madeira.'
              )}
            </p>
            <p>
              {t(
                'guide.intro.p2',
                'Para proteger o ecossistema, o acesso é limitado a 5.000 visitantes por dia. Por isso, comprar a passagem de barco com antecedência é essencial, especialmente nos feriados e alta temporada.'
              )}
            </p>
            <p>
              {t(
                'guide.intro.p3',
                'A ilha é dividida em duas vilas principais. Nova Brasília, no norte, é mais tranquila, ideal para famílias e quem quer estar próximo do Farol das Conchas. Encantadas, no sul, tem mais agito, vida noturna e atrai um público mais jovem.'
              )}
            </p>
            <p>
              {t(
                'guide.intro.p4',
                'A melhor época para praias é o verão (novembro a março), com águas mais claras e dias ensolarados. Para trilhas com menos chuva e menos gente, prefira março a maio ou setembro a novembro.'
              )}
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
}
